'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const ContentManager = require('./../component/ContentManager');
const mediator = require('./../../../core/mediator');

module.exports.init = function() {
    const contentNotEditable = require('./../config').settings.contents_not_editable;

    jQuery('body').on('click', '.bb-content', function(event) {
        let content = ContentManager.getContentByNode(jQuery(event.currentTarget));

        if (jQuery(event.target).parents('.cloud-edit-content:first').length === 0 && !jQuery('body').hasClass('prevent-plugins')) {
            if (null !== content && content.isEditable() && -1 === contentNotEditable.indexOf(content.type)) {
                mediator.publish('content:force:click', content);

                if (-1 !== _.indexOf(content.getForbiddenPlugins(), 'click')) {
                    return true;
                }

                mediator.publish('content:click', content);

                event.stopPropagation();
            }
        }
    });

    jQuery('body').on('mousedown', '.bb-content', function(event) {
        let content = ContentManager.getContentByNode(jQuery(event.currentTarget));

        if (jQuery(event.target).parents('.cloud-edit-content:first').length === 0 && !jQuery('body').hasClass('prevent-plugins')) {
            if (null !== content && content.isEditable() && -1 === contentNotEditable.indexOf(content.type)) {
                if (-1 !== _.indexOf(content.getForbiddenPlugins(), 'click')) {
                    return true;
                }

                mediator.publish('content:mousedown', content);

                event.stopPropagation();
            }
        }
    });
};
